import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { NavLink } from 'react-router-dom';

import { DASHBOARD_PAGE_PATH, OURMISSION_PAGE_PATH } from '../../constants/appPathConst';
import { LOADING, OPEN_SIDEBAR, REGISTERED_TRADEMARK_SYMBOL } from '../../constants/messageConst';
import bemNames from '../../generalUtils/benames';
import {
  IMG_AP_LOGO_LIGHT,
  IMG_DIP_LOGO_LIGHT,
  IMG_DIP_LOGO_DARK,
  IMG_AP_LOGO_DARK
} from '../../constants/imagesAssetsConst';
import CustomButton from '../../components/GeneralForm/CustomButton';
import DealershipsDropdown from './DealershipsDropdown';
import { navigationItemsMenuList } from '../../generalUtils/rbacUtils';

const bem = bemNames.create('sidebar');

const SidebarComponent = props => {
  const {
    isSidebarVisible,
    navigate,
    handleLayoutIsDisplaySidebar,
    screenSizeObj,
    allDealerList,
    themeArr,
    location,
    view
  } = props;
  const { themeColorObj, isLightTheme } = themeArr;

  const navigationItems = useMemo(() => navigationItemsMenuList(view), [view]);
  const renderMenuItem = useCallback(
    (item, mainkey) => {
      if (!item?.isvisible) {
        return null;
      }

      if (!item?.submenu) {
        return (
          <li key={mainkey} className="nav-item">
            <NavLink
              to={item?.link}
              onClick={() => {
                if (screenSizeObj?.isMobileScreen) {
                  setTimeout(() => {
                    handleLayoutIsDisplaySidebar(!isSidebarVisible);
                  }, 250);
                }
              }}
              end={true}
              className="nav-link"
            >
              <i className={`fa fa-fw ${item?.icon} mr-2`} />
              <span>{item?.label}</span>
            </NavLink>
          </li>
        );
      }

      return (
        <li key={mainkey} className="nav-item--nested" onClick={item?.nestedMenuOnClick}>
          <span className="nav-link">
            <i className={`fa fa-fw ${item?.icon} mr-2`} />
            <span>{item?.label}</span>
          </span>
          <ul className="nav flex-column" onClick={e => e.stopPropagation()}>
            <li className="nav-sub-item nested-submenu">
              {item?.submenu.map((submenuItem, index) => {
                const subkey = `${mainkey}-${index}`;
                if (submenuItem?.isvisible) {
                  return (
                    <NavLink key={subkey} to={submenuItem?.link} className="nav-sub-link">
                      <i className={`fa fa-fw ${submenuItem?.icon} mr-2`} />
                      <span>{submenuItem?.label}</span>
                    </NavLink>
                  );
                }
                return null;
              })}
            </li>
          </ul>
        </li>
      );
    },
    [screenSizeObj, handleLayoutIsDisplaySidebar, isSidebarVisible]
  );

  useEffect(() => {
    const activeItem = document.querySelector('.nav-link.active');
    if (activeItem) {
      activeItem.scrollIntoView({ block: 'center' });
    }

    const activeSubItem = document.querySelector('.nav-sub-link.active');
    if (activeSubItem) {
      const eleZero = activeSubItem.closest('.nav-item--nested');
      if (!eleZero?.parentNode?.classList?.contains(OPEN_SIDEBAR)) {
        eleZero?.classList.add(OPEN_SIDEBAR);
        eleZero?.scrollIntoView({ block: 'center' });
      }
    }
  }, [allDealerList, location?.pathname]);

  const NAME = `Autoport ${REGISTERED_TRADEMARK_SYMBOL}`;

  return (
    <aside
      className={bem.b(`${isSidebarVisible ? bem.m('open') : ''}`)}
      style={{
        background: isLightTheme
          ? `linear-gradient(180deg, ${themeColorObj?.['dark-400']}, ${themeColorObj?.['dark-700']}) no-repeat 0 0 / 100% 400px,${themeColorObj?.['dark-700']} repeat 100% 100%`
          : themeColorObj?.['dark-900']
      }}
    >
      <div
        rel="noopener noreferrer"
        className={bem.e('navbar-brand')}
        onClick={() => navigate(DASHBOARD_PAGE_PATH)}
      >
        <div className="ap-logo" title={NAME}>
          <img src={isLightTheme === false ? IMG_AP_LOGO_DARK : IMG_AP_LOGO_LIGHT} alt={NAME} />
        </div>
      </div>

      <div>
        <div className="sidebar__mobile-fluid">
          <div className="seldealer">
            <DealershipsDropdown {...props} />
          </div>
          <div className={bem.e('content')}>
            <ul className="nav flex-column">
              {allDealerList && allDealerList?.length > 0 ? (
                navigationItems?.map((item, index) => renderMenuItem(item, index))
              ) : (
                <span className="text-info-300 p-3">{LOADING}</span>
              )}
            </ul>
          </div>
        </div>
      </div>

      <div className="text-center">
        <img
          src={isLightTheme === false ? IMG_DIP_LOGO_LIGHT : IMG_DIP_LOGO_DARK}
          className="dip-logo"
          alt="DealerImagePro"
          onClick={() => {
            window.open('https://www.dealerimagepro.com/', '_blank');
          }}
        />
        <div className="mission-div">
          <CustomButton isLinkTag to={OURMISSION_PAGE_PATH} isLinkTagIncludeButtonClass color="dark-400">
            Our Mission
          </CustomButton>
        </div>
      </div>
    </aside>
  );
};

SidebarComponent.displayName = 'SidebarComponent';
export default memo(SidebarComponent);